export const buildUrlEnhancer = () => {
  if (typeof window === 'undefined') return {};
  return {
    page: {
      url: window.location.href,
      pathname: window.location.pathname,
    },
  };
};
